import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { trpc } from "../lib/trpc";
import { firstAllowedPath } from "../lib/pages";
import { Icon } from "./ui/Icon";
import { useTabActive } from "../lib/tabActive";

/**
 * Sayfa erişim koruması — kullanıcının grubu (Role.pages) bu sayfayı içermiyorsa
 * İLK izinli sayfaya yönlendirir; hiç izinli sayfa yoksa erişim-yok ekranı gösterir.
 * Süper admin her sayfaya erişir. Kimlik koruması ProtectedRoute'ta (bu bileşen üstünde).
 * NOT: Bu bir UI kolaylığıdır — asıl güvenlik backend requirePermission'dadır.
 */
export function PageGate({ pageKey, children }: { pageKey: string; children: ReactNode }) {
  const meQ = trpc.auth.me.useQuery(undefined, { staleTime: 60_000 });
  const tabActive = useTabActive();
  const user = meQ.data?.user;
  if (meQ.isLoading || !user) return null; // ProtectedRoute yükleme/oturum durumunu yönetir
  const pages: string[] = (user as { pages?: string[] }).pages ?? [];
  if ((user as { isSuperAdmin?: boolean }).isSuperAdmin || pages.includes(pageKey)) return <>{children}</>;

  const target = firstAllowedPath(pages);
  /**
   * YÖNLENDİRME YALNIZ ÖNDEKİ SEKMEDEN. Çoklu sekmede tüm açık sayfalar aynı anda mount
   * kalır; yetkisiz bir sayfa GİZLİ bir sekmede duruyorsa buradaki `<Navigate>` global
   * adresi değiştirir ve kullanıcı, göremediği bir sekme yüzünden baktığı sayfadan
   * fırlatılır. Pasif sekme sessizce yetki uyarısı gösterir; kullanıcı o sekmeye
   * geçtiğinde yönlendirme normal şekilde çalışır.
   */
  if (target && tabActive) return <Navigate to={target} replace />;
  return (
    <div className="empty-state" style={{ marginTop: 80 }}>
      <Icon name="alertTriangle" size={28} />
      <p className="ttl">Erişim yetkiniz yok</p>
      <p className="sub">Grubunuza henüz sayfa erişimi tanımlanmamış. Sistem yöneticinizle iletişime geçin.</p>
    </div>
  );
}
